import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { I18nComponent } from '@app/core/i18n/components/i18n.component';
import { FormSelectModule } from '@app/shared/components/form/components/form-select/form-select.module';
import { I18nData, I18nRedirector } from '@app/core/i18n/services';
import { OpenI18nPopinDirective } from './directive/open-i18n-popin.directive';

@NgModule({
  imports: [CommonModule, FormsModule, MatDialogModule, FormSelectModule],
  declarations: [I18nComponent, OpenI18nPopinDirective],
  providers: [I18nData, I18nRedirector],
  exports: [I18nComponent, OpenI18nPopinDirective],
  entryComponents: [I18nComponent]
})
export class I18nModule {}
